import React from "react"
import { Route } from "react-router-dom"
import { Admin, Resource, useStore, StoreContextProvider, CustomRoutes } from "react-admin"
import {i18nProvider} from "i18n"
//import { McsLayout } from "components/layouts"
import users from "components/pages/users"
import companies from "components/pages/companies"
import equipments from "components/pages/equipments"
import objects from "components/pages/objects"
import devices from "components/pages/devices"
import { Dashboard } from "components/pages/dashboard"
import dashboards from "components/pages/dashboard-management"
import { themes, ThemeName } from "themes/themes"
import {default as authProvider} from "api/auth"
import {queryClient, default as dataProvider} from "api/data"
import {WshubComponent} from "components/wshub"
import {Action} from "api/wshub/wshub.pb"
import { McsLayout } from "components/ui/layouts"
import { store } from "store"

//const UserList = React.lazy(() => import("components/UserList"))
//layout={McsLayout}

function App(): JSX.Element {
    const [themeName] = useStore<ThemeName>('themeName', 'default')
    const lightTheme = themes.find(theme => theme.name === themeName)?.light
    const darkTheme = themes.find(theme => theme.name === themeName)?.dark

    return (
        <StoreContextProvider value={store}>
            <WshubComponent 
                callback={(m, ws) => {
                    queryClient.invalidateQueries({ queryKey: m.id && m.id !== "" ? [m.resource, m.id] : [m.resource] })
                    if (m.body?.length > 0 && m.action === Action.CREATE) {
                        queryClient.setQueryData([m.resource], (oldData: any) => {
                            if (!oldData) {
                                return m.body
                            }
                            return [...oldData, ...m.body as any]
                        })
                    }
                }}>
                <Admin 
                    lightTheme={lightTheme}
                    darkTheme={darkTheme}
                    defaultTheme="dark"
                    i18nProvider={i18nProvider}
                    dashboard={Dashboard}
                    queryClient={queryClient}
                    disableTelemetry
                    authProvider={authProvider}
                    dataProvider={dataProvider} 
                    layout={McsLayout}>
                    <Resource name="users" {...users} />
                    <Resource name="companies" {...companies} />
                    <Resource name="equipments" {...equipments} />
                    <Resource name="objects" {...objects} />
                    <Resource name="devices" {...devices} />
                    <Resource name="dashboards/management" {...dashboards} />
                    <CustomRoutes>
                        <Route path="/equipments/:id/audit" element={<equipments.audit />} />
                        <Route path="/companies/:id/schedules" element={<companies.schedules />} />
                        <Route path="/companies/:id/audit" element={<companies.audit />} />
                        <Route path="/companies/:id/schedules/create" element={<companies.schedulecreate />} />
                        <Route path="/companies/:companyid/schedules/:id" element={<companies.scheduleedit />} />
                        <Route path="/objects/:id/schedules" element={<objects.schedules />} />
                        <Route path="/objects/:id/schedules/create" element={<objects.schedulecreate />} />
                        <Route path="/objects/:objectid/schedules/:id" element={<objects.scheduleedit />} />
                        <Route path="/objects/:id/audit" element={<objects.audit />} />
                        <Route path="/objects/flow" element={<objects.flow group="gas"/>} />
                        <Route path="/objects/map" element={<objects.map group="gas" />} />
                        <Route path="/devices/:id/chart" element={<devices.chart />} />
                        <Route path="/devices/:id/audit" element={<devices.audit />} />
                        <Route path="/devices/:id/data" element={<devices.data />} />
                        <Route path="/devices/:devid/schedules/:id" element={<devices.scheduleedit />} />
                        <Route path="/devices/:id/schedules" element={<devices.schedules />} />
                        <Route path="/devices/:id/schedules/create" element={<devices.schedulecreate />} />
                        <Route path="/devices-ddt" element={<devices.listddt />} />
                        <Route path="/references/drivers" element={<equipments.listdrivers />} />
                        <Route path="/references/drivers/:id/show" element={<equipments.listdriverparams />} />
                        <Route path="/settings" element={<></>} />
                        <Route path="/profile" element={<></>} />
                    </CustomRoutes>
                </Admin>
            </WshubComponent>
        </StoreContextProvider>
    )
}

export default App
